<style scoped>
  .management-plan-button{
    padding-top: 2px;
    padding-right: 10px;
    padding-bottom: 2px;
    padding-left: 10px;
  }
  .management-plan-button-leading-space {
    margin-left: 7px;
  }
  .management-plan-button-column{
    text-align:right;
  }
  .management-plan-button-container{
    margin-right:0;
  }
  .management-plan-dialog-no{
    background-color: #863A21;
  }
  .management-plan-dialog-yes{
    background-color: #3F6E75;
  }
  .management-plan-link-column{
    padding-top:10px;
  }
  .management-plan-warning{
    color: #863A21;
  }
</style>
<!-- eslint-disable max-len -->
<template>
  <div class='view-contents'>
    <div class="row title-row">
      <div class="col section-title">Create New Management Plan</div>
    </div>
    <div class="fluid management-plan-button-container">
      <b-row>
        <b-col class='management-plan-link-column'>
          <router-link v-if="currentSite" :to="{ name: 'ManagementPlans', params: { id: currentSite.Id } }">
            <b-icon icon="caret-left-fill"></b-icon>
            <span>Back to Management Plans</span>
          </router-link>
        </b-col>
        <b-col class='management-plan-button-column'>
          <span v-if='startNewPlanWarning' class='management-plan-warning'>Please select only Sites with an approved Site Assessment.</span>
          <b-button id="btnStartNewPlan" pill size="sm" variant="primary" class="management-plan-button management-plan-button-leading-space" v-b-modal="'startNewPlanModal'" :disabled="btnStartNewPlanDisabled">Start New Plan</b-button>
          <b-modal id="startNewPlanModal" title="Confirm New Management Plan" @ok="ok">
            <p>
              <span>Data from the selected Sites will be copied into a new {{managementPlan.planType}}, and the plan will be associated to these Sites. </span>
              <span>These selections cannot be changed once you begin the Plan.</span>
            </p>
            <p>
              <span>Are you sure you want to create a new {{managementPlan.planType}} for the selected Site(s)?</span>
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
              <b-button size="sm" variant="danger" @click="cancel" class='management-plan-dialog-no'>No</b-button>
              <b-button size="sm" variant="success" @click="ok" class='management-plan-dialog-yes'>Yes - use these selections</b-button>
            </template>
          </b-modal>
        </b-col>
      </b-row>
    </div>
    <div class="row site-section-wrapper">
      <div class="col-4">
        <ManagementPlanDetails/>
      </div>
      <div class="col-8 right-col">
        <ManagementPlanMap/>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks */
import { mapState } from 'vuex';
import ManagementPlanDetails from '@/components/managementPlans/ManagementPlanDetails.vue';
import ManagementPlanMap from '@/components/managementPlans/ManagementPlanMap.vue';
import showSidePanelToggle from '../mixins/showSidePanelToggle';

export default {
  name: 'ManagementPlan',
  mixins: [showSidePanelToggle],
  components: {
    ManagementPlanDetails,
    ManagementPlanMap,
  },
  computed: {
    ...mapState(['currentSite', 'config']),
    ...mapState('ManagementPlan', { managementPlan: (state) => state.managementPlan }),
    btnStartNewPlanDisabled() {

      const hasUnapprovedSiteAssessment = this.managementPlan.sites.filter(
        (site) => site.graphic.attributes.siteAssessmentStatus !== this.config.siteAssessmentForm.submitStatus.Approved,
      ).length > 0;

      const value = this.managementPlan.planType == null
        || this.managementPlan.sites.length === 0
        || hasUnapprovedSiteAssessment;

      return value;
    },
    startNewPlanWarning() {
      return this.managementPlan.sites.filter(
        (site) => site.graphic.attributes.siteAssessmentStatus !== this.config.siteAssessmentForm.submitStatus.Approved,
      ).length > 0;
    },
  },
  mounted() {
    this.$store.dispatch('fetchConfiguration').then(() => {});
    this.$store.dispatch('setShowSidePanel', false);
  },
  methods: {
    async ok() {
      await this.$store.dispatch(
        'ManagementPlan/postManagementPlan',
        this.managementPlan,
      ).then(async () => {});
      this.$router.push({
        name: 'ManagementPlanForm',
        params: { id: this.managementPlan.id, type: 'insert' },
      });
    },
  },
};
</script>
